import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LiveDashboard.css';
import secureLocalStorage from 'react-secure-storage';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import BookingList from './BookingList';
import TotalCard from './TotalCard';
import DepositList from './DepositList';
import AgentList from './AgentList';
import FetchLoading from '../../Loading/FetchLoading';

const LiveDashboard = () => {
  const navigate = useNavigate();
  const aminInfo = secureLocalStorage.getItem('admin-info');
  let token = aminInfo?.token;
  const [isLoading, setIsLoading] = useState(true);
  const [queuesData, setQueuesData] = useState([]);
  const [allQueuesData, setAllQueuesData] = useState([]);

  useEffect(() => {
    const fetchQueuesData = () => {
      setIsLoading(true); // Set loading to true before the fetch

      fetch(`https://api-b2b.fasttracktourism.com/admin/report/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setQueuesData(data);
          setAllQueuesData(data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    fetchQueuesData();
  }, [token]);

  return (
    <Box className="dashboard-live">
      <AdminHeader />
      <Box sx={{ p: 2 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalBooking}
              background="#D1E9FF"
              text="Total Booking"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.Ticketed}
              background="#F7D800"
              text="Total Ticketed"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.Cancelled}
              background="crimson"
              text="Total Cancelled"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalAgent}
              background="gray"
              text="Total Agents"
            />
          </Grid>
        </Grid>

        {/* -------------------------- */}
        <Grid container sx={{ overflowY: 'hidden', maxHeight: '40vh' }}>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: 16, fontWeight: 500, mt: 1 }}>
              Air Ticket Live Booking
            </Typography>
            <Box>
              {!isLoading ? (
                <BookingList
                  data={queuesData?.TotalBookingData}
                  isLoading={isLoading}
                />
              ) : (
                <FetchLoading />
              )}
            </Box>
          </Grid>
        </Grid>
        {/* --------------------------------- */}

        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalDeposit}
              background="#D1E9FF"
              text="Total Deposit"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalDepositPending}
              background="#F7D800"
              text="Total Deposit Pending"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalDepositApproved}
              background="crimson"
              text="Total Deposit Approved"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TotalCard
              data={allQueuesData?.TotalDepositRejected}
              background="gray"
              text="Total Deposit Rejected"
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          sx={{ overflowY: 'hidden', maxHeight: '50vh' }}
        >
          <Grid item md={7} sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              Current Deposit
            </Typography>
            <Box>
              {!isLoading ? (
                <DepositList
                  data={queuesData?.TotalDepositData}
                  isLoading={isLoading}
                />
              ) : (
                <FetchLoading />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Typography sx={{ fontSize: 16, fontWeight: 500, mt: 1 }}>
              Agents List
            </Typography>
            <Box>
              {!isLoading ? (
                <AgentList data={queuesData?.AgentData} />
              ) : (
                <FetchLoading />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default LiveDashboard;
